// 用户权限变量
const rolePermission: Record<string, string[]> = {
  // 成品盘点-草稿-盘点
  goodsStoreOrderEdit: ['goodsStoreOrderDraft', 'goodsStoreOrderSubmit'],
  // 成品调拨-草稿-调拨
  goodsStoreTransferOrderEdit: [
    'goodsStoreTransferOrderDraft',
    'goodsStoreTransferOrderSubmit',
  ],
  // 生产单-草稿-保存
  produceOrderEdit: ['produceOrderDraft', 'produceOrderSubmit'],
  // 生产单-修改物料BOM
  produceMaterialBOMEdit: ['goodsEdit', 'produceOrderSubmit'],
  // 生产单-打印
  produceOrderPrint: ['produceOrderPrint', 'produceOrderGet', 'goodsGet'],
  // 商品编辑
  goodsEdit: ['goodsEdit'],
  // 物料编辑
  materialEdit: ['materialEdit'],
  // 采购单-草稿-保存
  materialPurchaseOrderEdit: [
    'materialPurchaseOrderDraft',
    'materialPurchaseOrderSubmit',
  ],
  // 采购退货单-草稿-保存
  materialPurchaseRefundOrderEdit: [
    'materialPurchaseRefundOrderDraft',
    'materialPurchaseRefundOrderSubmit',
  ],
  // 物料盘点-草稿-盘点
  materialStoreOrderEdit: [
    'materialStoreOrderDraft',
    'materialStoreOrderSubmit',
  ],
  // 物料调拨-草稿-调拨
  materialStoreTransferOrderEdit: [
    'materialStoreTransferOrderSubmit',
    'materialStoreTransferOrderDraft',
  ],
  // 物料库存流水
  materialStoredRecordGet: ['materialStoredRecordGet'],
  // 生产出库-草稿-出库
  produceStoreOutOrderEdit: [
    'produceStoreOutOrderDraft',
    'produceStoreOutOrderSubmit',
  ],
  // 生产入库-草稿-入库
  produceStoreInOrderEdit: [
    'produceStoreInOrderDraft',
    'produceStoreInOrderSubmit',
  ],
  // 物料领料-草稿-领料
  materialPickOrderEdit: ['materialPickOrderDraft', 'materialPickOrderSubmit'],
  // 物料退料-草稿-退料
  materialRefundOrderEdit: [
    'materialRefundOrderDraft',
    'materialRefundOrderSubmit',
  ],
  // 出库退货-草稿-退货
  shipmentReturnOrderEdit: ['goodsRejectOrderDraft', 'goodsRejectOrderSubmit'],
  // 次品返厂-草稿-返厂
  reworkOrderEdit: ['reworkOrderSaveDraft', 'reworkOrderSubmit'],
};
export default rolePermission;
